module.exports = __webpack_public_path__ + "static/media/EventAttendanceLocation.1fb85bfe.svg";